import { useMutation } from "@tanstack/react-query";

import { calculateCropMixPotentialPayout } from "services";

import { CALCULATE_CROP_MIX_POTENTIAL_PAYOUT } from "consts";

export const useCalculateCropMixPotentialPayout = () =>
  useMutation({
    mutationKey: [CALCULATE_CROP_MIX_POTENTIAL_PAYOUT],
    mutationFn: calculateCropMixPotentialPayout,
  });
